import { Box, Typography } from '@mui/material';
import { CHART_GREEN } from '../../../theme/theme-colors';

interface TimerDurationDisplayProps {
  time: string;
  ariaLabel: string;
  color?: string;
}

/** Large centered M:SS (or H:MM:SS) duration readout shared by program and countdown timer widgets. */
export function TimerDurationDisplay({ time, ariaLabel, color = CHART_GREEN }: TimerDurationDisplayProps) {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      flexShrink={1}
      aria-label={ariaLabel}
    >
      <Typography component="p" sx={{ color, fontSize: '5rem', fontWeight: 600 }}>
        {time}
      </Typography>
    </Box>
  );
}
